import { Box, Grid, Alert } from "@mui/material";
import { useDispatch } from "react-redux";
import { useTypeOfPlacesQuery } from "./hooks/useTypeOfPlacesQuery";
import { TypeOfPlaceCard } from "./TypeOfPlacesCard";
import { PaginationLoadingOverlay } from "../../../../../../../clients/PaginationLoadingOverlay";
import { quoteCreateActions } from "../../../../../../../../redux/features/quotes/quote-create-advanced";
import { QueryState } from "../../../../../../../shared/components/query-states/GlobalQueryState";

export const TypeOfPlaces = ({ categoryType, selected }) => {
  const dispatch = useDispatch();
  const { setPlace } = quoteCreateActions;
  const typeOfPlacesQuery = useTypeOfPlacesQuery({ categoryType });

  const places = typeOfPlacesQuery.data?.items || [];

  const handleSelectPlace = (place) => {
    dispatch(setPlace(place));
  };

  return (
    <Grid container rowSpacing={2} columnSpacing={4} sx={{ display: "flex", justifyContent: "center", maxWidth: "850px", margin: "0 auto" }}>
      <Grid item xs={12}>
        <QueryState isLoading={typeOfPlacesQuery.isLoading} isError={!!typeOfPlacesQuery.isError} serviceName="Type of places" />
      </Grid>
      {places.map((place) => (
        <Grid item xs={12} sm={6} md={4} key={place.uid}>
          <TypeOfPlaceCard imageUrl={place.imageUrl} place={place} onSelect={handleSelectPlace} selected={selected?.uid === place.uid} />
        </Grid>
      ))}
    </Grid>
  );
};
